import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDMtk_265qjpNQGG8SVVlB2olIm2LdzZBI",
  authDomain: "easyproperty-ca3ec.firebaseapp.com",
  projectId: "easyproperty-ca3ec",
  storageBucket: "easyproperty-ca3ec.firebasestorage.app",
  messagingSenderId: "487820576397",
  appId: "1:487820576397:web:77afe80bb4d03e9e61c4c4"
};

const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app; 